import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/questionnaire';

/**
 * eラーニングアンケートのState型
 */
export interface IQuestionnaireState {
	blocks: Actions.IQuestionnaireBlock[];
	displayTmpSaveBtn: boolean;
	mustAnswerFlg: number;
	startTime: string;
	renewalDate: string;
	optionsAtGrid: Actions.IOption[];
	periodJudgment: number;
	enqueteName: string;
	scoreItemsRegisterFlag: string;
	selectedQuestionnaire: number;
	respondentCategoryFlg: string;
}

/**
 * eラーニングアンケートのState初期値
 */
const initialState: IQuestionnaireState = {
	blocks: [],
	displayTmpSaveBtn: false,
	enqueteName: '',
	mustAnswerFlg: 0,
	optionsAtGrid: [],
	periodJudgment: 0,
	renewalDate: '',
	respondentCategoryFlg: '',
	scoreItemsRegisterFlag: '',
	selectedQuestionnaire: 0,
	startTime: '',
};

/**
 * eラーニングアンケート用reducer
 * @param state State
 * @param action アクション
 */
const questionnaire = (state: IQuestionnaireState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}
	if (isType(action, Actions.setQuestionnaireParams)) {
		return {
			...state,
			blocks: action.payload.blocks,
			displayTmpSaveBtn: action.payload.displayTmpSaveBtn,
			enqueteName: action.payload.enqueteName,
			mustAnswerFlg: action.payload.mustAnswerFlg,
			periodJudgment: action.payload.periodJudgment,
			renewalDate: action.payload.renewalDate,
			respondentCategoryFlg: action.payload.respondentCategoryFlg,
			scoreItemsRegisterFlag: action.payload.scoreItemsRegisterFlag,
			startTime: action.payload.startTime,
		};
	}

	if (isType(action, Actions.setQuestionnaireGridOptions)) {
		return {
			...state,
			optionsAtGrid: action.payload.options,
		};
	}

	if (isType(action, Actions.clearQuestionnaireParams)) {
		return initialState;
	}

	return state;
};

export default questionnaire;



// WEBPACK FOOTER //
// ./src/reducers/questionnaire.ts